module.exports = __webpack_public_path__ + "static/img/default_avatar.5d65e843.png";